import React from 'react';
import BaseChatMessage from './BaseChatMessage';

export default class ChatMessageReceived extends BaseChatMessage {
  render() {
    return (
      <div className={'message in'} key={this.props.keyValue}>
        <label>{this.props.message}</label>
      </div>
    );
  }
}
